import CMSRender from "aldoo-ra/CMS/cms-render"
import Accordion from "aldoo-ra/Accordion"

function FAQ() {
  return (
    <div className="grid w-full mx-auto my-[100px] grid-cols-1 gap-3">
      <CMSRender
        //this is the type of content to render
        contentType="FAQ Section"
        renderItem={(data) => {
          return (
            <Accordion
              variant="aqua"
              items={data?.questions}
              title={data?.title}
            />
          )
        }}
      />
    </div>
  )
}

export const AldooComponent = {
  id: 'FAQ',
  component: FAQ,
  input: {},
  meta: {
    name: 'FAQ Section',
    description: 'Frequently asked questions with expandable accordion',
    category: 'Marketing',
  },
}

export default FAQ
